import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import { FormBuilder, FormControl, Validators } from '@angular/forms';
import {IMyDefaultMonth, INgxMyDpOptions } from '@mksasi/ngx-mydatepicker';
import { ValidationService } from '../../../validators/validation.service';
import { AppService } from "src/app/services/services";

@Component({
    selector: 'nri-app-guardian-info',
    templateUrl: './guardian-info.component.html',
    styleUrls: ['./guardian-info.component.scss']
})

export class GuardianInfoComponent implements OnInit{
    @Input() data: any;
    @Input() guardianGetData: any;
    @Output() guardianFormValid = new EventEmitter();
    countryCode: any;
    countryList: any;
    public defaultMonth: any = {
        defMonth: ''
    };
    docTypeList: any;
    majorDate: any;
    guardianDOB: any;
    totalShare: any = 0;
    codeKeyword = 'TeleCode';
    countryCodeError: boolean;
     guardianIDs:any = [
        {value:"A",name:"Aadhaar"},
        {value:"P",name:"PAN"},
        {value:"VP",name:"Valid Passport"},
        {value:"DL",name:"Driving License"},
        // {value:"N",name:"No Document"}
    ]
    // Every guardian field is optional per the regulatory field matrix.
    // Guardian date of birth and guardian address are no longer collected.
    guardianForm:any = this.formBuilder.group({
        'GuardianFirstName': [''],
        'GuardianLastName': [''],
        'GuardianRelationship': ['', Validators.required],
        // 'GuardianCountryCode': ['',Validators.required],
        'GuardianMobile': ['', [Validators.minLength(7)]],
        'GuardianEmail':['', null, ValidationService.emailValidator],
        'GuardianIdProof': [''],
        'GuardianIdProofNumber': ['']
    });
    guardianList: any;
    options: INgxMyDpOptions = {
        dateFormat: 'dd/mm/yyyy',
    };
    guardianValue: any = {};

    constructor(public formBuilder: FormBuilder, public _http: AppService){
        this.countryList = this._http.countryList;
    }

    ngOnInit(){
        const d: Date = new Date();
        let pastDate = new Date();
        pastDate.setFullYear(d.getFullYear() - 90);
        this.options = {
            dateFormat: 'dd/mm/yyyy',
            showTodayBtn: false,
            disableSince: { year: d.getFullYear() - 18, month: d.getMonth() + 1, day: d.getDate() + 1 },
            disableUntil: { year: pastDate.getFullYear(), month: pastDate.getMonth() + 1, day: pastDate.getDate() }
        }
        let m = (d.getMonth()+1).toString();
        let n  = d.getMonth()+1;
        let y = (d.getFullYear()-18).toString();
        if(n < 10){
          m = "0"+m;
        }
        this.defaultMonth =  {
            defMonth:  m+"/"+y
        }

        this._http.getMasters().subscribe(data=>{
            if(data && data.DocumentTypeList){
                this.docTypeList  = data.DocumentTypeList;
                this._http.getStatus().subscribe(d=>{
                  
                    this.docTypeList = data.DocumentTypeList.filter((e:any)=>{
                      return !e.OCI
                    })
                  
                })
            }
            if(data && data.NomineeList){
              this.guardianList = data.NomineeList
            }
          });
          this.onGuardianFormValueChange();
          if(this.guardianGetData && (this.guardianGetData.GuardianFirstName || this.guardianGetData.GuardianLastName)){
            this.guardianForm.patchValue({
                'GuardianFirstName': this.guardianGetData.GuardianFirstName,
                'GuardianLastName': this.guardianGetData.GuardianLastName,
                'GuardianRelationship': this.guardianGetData.GuardianRelationship,
                "GuardianMobile": this.guardianGetData.GuardianMobile,
                // "GuardianCountryCode" :this.guardianGetData.NomineeCountryCode,
                "GuardianEmail": this.guardianGetData.GuardianEmail,
                'GuardianIdProof':this.guardianGetData.GuardianIdProof,
                'GuardianIdProofNumber':this.guardianGetData.GuardianIdProofNumber
            });
            this.countryCode = this.guardianGetData.GuardianCountryCode;
            this.guardianValue.GuardianCountryCode = this.countryCode;
            let param = {
                status: true,
                data: this.guardianValue
            }
            this.guardianFormValid.emit(param);
          }
    }

    onGuardianFormValueChange(){
        this.guardianForm.valueChanges.subscribe( (value:any) => {
            // if(this.guardianForm.valid){
                this.guardianValue.GuardianFirstName = this.guardianForm.value.GuardianFirstName;
                this.guardianValue.GuardianLastName = this.guardianForm.value.GuardianLastName;
                this.guardianValue.GuardianRelationship  = this.guardianForm.value.GuardianRelationship;
                this.guardianValue.GuardianMobile = this.guardianForm.value.GuardianMobile ?this.guardianForm.value.GuardianMobile :'' ;
                this.guardianValue.GuardianCountryCode =this.countryCode ? this.countryCode : this.countryCode?.TeleCode ? this.countryCode?.TeleCode : '';
                this.guardianValue.GuardianEmail = this.guardianForm.value.GuardianEmail ?this.guardianForm.value.GuardianEmail :'' ;
                this.guardianValue.GuardianIdProof = this.guardianForm.value.GuardianIdProof;
                this.guardianValue.GuardianIdProofNumber = this.guardianForm.value.GuardianIdProofNumber;
                let param = {
                    status: true,
                    data: this.guardianValue
                }
                this.guardianFormValid.emit(param)
            // }else{
            //     let param = {
            //         status: false,
            //         data: ''
            //     }
            //     this.guardianFormValid.emit(param)
            // }
        });
    }

    public noWhitespaceValidator(control: FormControl) {
        return (control.value || '').trim().length? null : { 'whitespace': true };       
    }

    setCountryCode(event:any){
        const regex = /[^0-9]/g;
        const input = event.target.value;
        event.target.value = input.replace(regex, '');
        let a:any = this.guardianForm.value.GuardianCountryCode?.split('-');
        this.countryCode = a[0];
    }

    noSpace(event: any){
        const pattern = new RegExp('^[-a-zA-Z0-9@._\b]+$');
        const key = String.fromCharCode(!event.charCode ? event.which : event.charCode);
        if (!pattern.test(key) && event.charCode !== 0) {
            event.preventDefault();
            return;
        }
    }

    // onInputChange(event:any){
    //     const pattern = new RegExp('^[a-zA-Z \b]+$');
    //     const key = String.fromCharCode(!event.charCode ? event.which : event.charCode);
    //     if (!pattern.test(key) && event.charCode !== 0) {
    //         event.preventDefault();
    //         return;
    //     }
    // }

    onInputChange(event: any) {
        const pattern = /^[a-zA-Z \b]+$/;
        const inputText = event.target.value;
      
        if (!pattern.test(inputText)) {
          // Remove invalid characters from the input value
          event.target.value = inputText.replace(new RegExp(`[^a-zA-Z \b]+`, 'g'), '');
        }
      }
      

    spaceValidation(event:any, name: any){
        const input = event.target.value;
        event.target.value = input.replace(/^\s+|\s+$|\s+(?=\s)/g, "");
    }

    alphaNumeric(event: any){
        const pattern = new RegExp('^[a-zA-Z0-9\b]+$');
        const key = String.fromCharCode(!event.charCode ? event.which : event.charCode);
        if (!pattern.test(key) && event.charCode !== 0) {
            event.preventDefault();
            return;
        }
    }

    onlyNumberKey(event: any) {
        const pattern = new RegExp('^[0-9\b]+$');
        const key = String.fromCharCode(!event.charCode ? event.which : event.charCode);
        if (!pattern.test(key) && event.charCode !== 0) {
            event.preventDefault();
            return;
        }
    }

     selectCodeEvent(event: any){
        this.countryCode = event.TeleCode;
        // this.nomineeForm.controls.NomineeCountryCode.setValue(event.TeleCode);
        this.guardianValue.GuardianCountryCode = event.TeleCode;
        let param = {
            status: true,
            data: this.guardianValue
        }
        this.guardianFormValid.emit(param)
        // this.onGuardianFormValueChange();
    }
    restrictEnter(args: any) {
        if (args.key === "Enter" && args.keyCode == 13)
          args.preventDefault();
      }
      telcode(event: any){
        if(event.length > 3){
          event = event.substring(0, event.length-1);
        }
        this.countryCode = event;
        this.guardianValue.GuardianCountryCode = event;
        let param = {
            status: true,
            data: this.guardianValue
        }
        this.guardianFormValid.emit(param)
      }
      checkCode() {
        let c = '';
        if (this.countryCode && this.countryCode.TeleCode) {
          c = this.countryCode.TeleCode;
        }
        let code = this.countryList.filter((e: any) => {
          return e.TeleCode === c;
        });
        this.guardianValue.GuardianCountryCode = this.countryCode;
        let param = {
            status: true,
            data: this.guardianValue
        }
        this.guardianFormValid.emit(param)
        if (!code || code.length === 0) {
          this.countryCodeError = true;
        } else {
          this.countryCodeError = false;
        }
      }
      numericOnly(event: any) {
        const pattern = /^[0-9\b]+$/;
        const inputText = event.target.value;
      
        if (!pattern.test(inputText)) {
          // Remove non-numeric characters from the input value
          event.target.value = inputText.replace(new RegExp(`[^0-9]+`, 'g'), '');
        }
      }
      emailOnly(event: any) {
        const pattern = /^[a-zA-Z0-9._@]+$/;
        const inputText = event.target.value;
      
        if (!pattern.test(inputText)) {
          event.target.value = inputText.replace(new RegExp(`[^a-zA-Z0-9._@]+`, 'g'), '');
        }
    }
}